import { initReactI18next } from "react-i18next"

import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import HttpApi from "i18next-http-backend"

import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
} from "src/domains/i18n/language/supported-languages"

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug:
      process.env.NODE_ENV !== "production" &&
      !process.env.REACT_APP_I18N_DEBUG_OFF,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    detection: {
      order: ["cookie", "localStorage", "navigator"],
      caches: ["cookie", "localStorage"],
      // Cookie
      lookupCookie: "currentLang",
      cookieDomain: "minut.com",
      cookieMinutes: 60 * 24 * 30,
      cookieOptions: { path: "/", sameSite: "strict" },
      // Localstorage
      lookupLocalStorage: "language",
    },
  })
